<template>
    <div>
        <!-- <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        Certificate Authentication History Dashboard
                    </div>
                </div>
            </div>
        </div> -->

        <div class="row " v-for="agencyDetails in agency_certificates_for_vetting" :key="agencyDetails.agency">
            <div class="col-lg-12" v-if="agencyDetails.certificates_history.length > 0">
                <div class="card">
                    <div class="card-body">
                        <AuthenticationHistoryTable :agency="agencyDetails.agency" :certificates="agencyDetails.certificates_history" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthenticationHistoryTable from "./tables/authenticationHistoryTable.vue";
import { vettingComputed, vettingMethods } from "../../state/helpers";

export default {
    //eslint-disable-next-line
    components: { AuthenticationHistoryTable },
    data: () => ({
        items: [
            { id: 1, name: "yes" },
            // { id: 2, name: "no" },
        ],
    }),
    computed: {
        ...vettingComputed,
    },
    methods: { ...vettingMethods },
    mounted() {
        this.setCertificatesForVetting().then(() => {
            //eslint-disable-next-line
            // console.log(this.agency_certificates_for_vetting);

            for (let i = 0; i < this.agency_certificates_for_vetting.length; i++) {
                //eslint-disable-next-line
                console.log("hello", this.agency_certificates_for_vetting[i].agency);
            }
            //eslint-disable-next-line
            console.log("Historical Certificates", this.certificates_history);
        });
    },
};
</script>

<style lang="scss" scoped></style>
